export default "__VITE_ASSET__BMigUnrW__"